import { Component, inject, OnInit } from "@angular/core";
import { MobileWebViewService } from "src/app/services/mobile-web-view.service";

@Component({
    selector: "app-about-us",
    templateUrl: "./about-us.component.html",
    styleUrls: ["./about-us.component.scss"],
    standalone: false
})
export class AboutUsComponent implements OnInit {
  isMobileWebView$ = inject(MobileWebViewService).isMobileWebView$;

  ngOnInit() {}

  scrollTo(id: string) {
    const element = window.document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: "smooth", inline: "nearest" });
    }
  }
}
